import {
  Section,
  ReadOnlyField,
  Stack,
  If,
} from '@fashionnovateam/nova-ui-toolkit';
import { useMemo } from 'react';
import { VendorCatalogItem } from '../../../../Lib/Hooks/ItemService';

type ShoeDetailsSectionProps = {
  item: VendorCatalogItem | undefined;
};

function ShoeDetailsSection({ item }: ShoeDetailsSectionProps) {
  const isWomenShoes = useMemo(
    () => !!item?.division?.toLowerCase().includes('women'),
    [item?.division],
  );

  return (
    <Section
      icon="pencil-edit/pencil-eraser-edit-line"
      title="Shoe Details"
      color="pink"
      iconVariant="solid"
      separateHeader={false}
      withoutShadow
      withoutBorder
      iconColor="black"
      data-testid="shoe-details-readonly-section"
    >
      <Stack direction="col" className="gap-3">
        <Stack direction="row" className="gap-0.5">
          <If condition={isWomenShoes}>
            <ReadOnlyField
              className="flex-1"
              label="Heel Height"
              value={item?.heel_height}
              id="heel-height"
            />
            <ReadOnlyField
              className="flex-1"
              label="Heel Type"
              value={item?.heel_type}
              id="heel-type"
            />
          </If>
          <ReadOnlyField
            className="flex-1"
            label="Shoe Style"
            value={item?.shoe_style}
            id="shoe-style"
          />
        </Stack>
      </Stack>
    </Section>
  );
}

export default ShoeDetailsSection;
